import React, { Suspense } from 'react';
import {
  BrowserRouter, Route, Routes, Navigate,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DefaultLayout } from '../layouts';
import { pageRoutes } from './config';
import { isLoggedIn } from '../utils';
import Loader from '../components/Loader';

function FinalRoute({ route }) {
  const { token } = useSelector((state) => state.authentication);

  if (!route.public && !isLoggedIn()) return <Navigate to="/login" />;
  if (route.role && route.role !== token.role) return <div>Page not found!!</div>;

  return route.layout === 'blank' ? (
    <route.component />
  ) : (
    <DefaultLayout>
      <Suspense fallback={<Loader />}>
        <route.component />
      </Suspense>
    </DefaultLayout>
  );
}

function Router() {
  const { token } = useSelector((state) => state.authentication);

  const DefaultRoute = token.role === 'Customer' ? '/projects' : token.role === 'Sustainability Architect' ? '/services' : '/login';

  return (
    <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <Routes>
        <Route path="/" element={<Navigate to={DefaultRoute} />} />
        {pageRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={<FinalRoute route={route} />} />
        ))}
        <Route path="*" element={<div>Page not found!!</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
